import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import useLocales from "../../hooks/useLocales";
import { styled } from "@mui/styles";
import AdvancedFilterIcon from "@mui/icons-material/DesignServices";
import { Typography } from "@mui/material";

type Anchor = "top" | "left" | "bottom" | "right";

interface ICustomDrawerProps {
  direction: Anchor;
  listProps: any[];
}

const CustomDrawer: React.FC<ICustomDrawerProps> = ({
  direction,
  listProps,
}) => {
  const { translate } = useLocales();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const list = (anchor: Anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        marginTop: 24,
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontSize: 18,
          fontWeight: "bold",
          marginBottom: 4,
        }}
      >
        {translate("actions.advancedFilter")}
      </Typography>
      <Divider />
      <List>
        {listProps.map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      {([direction] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <DrawerButton
            onClick={toggleDrawer(anchor, true)}
            startIcon={<AdvancedFilterIcon />}
          >
            {translate("actions.advancedFilter")}
          </DrawerButton>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
};

const DrawerButton = styled(Button)({
  boxShadow: "none",
  fontSize: 16,
  padding: "6px 12px",
  color: "#999999",
  border: "1px solid #D9D9D9",
  lineHeight: 1.5,
  position: "relative",
  height: "46px",
  fontWeight: "400",
  textDecoration: "none",
  textTransform: "none",
  "& span": {
    textDecoration: "none",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
  "&:hover": {
    background: "none",
    color: "#853EF8",
    "& svg": {
      color: "#853EF8",
    },
  },
});

export default CustomDrawer;
